var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "big" },
    [
      _c("div", { staticClass: "toolbar-box" }, [
        _c(
          "div",
          { staticClass: "btn-group" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", icon: "el-icon-plus" },
                on: { click: _vm.openAddDialog },
              },
              [_vm._v(_vm._s(_vm.$t("trustDecision.addIP")))]
            ),
            _c(
              "el-button",
              {
                attrs: { type: "primary", icon: "el-icon-refresh" },
                on: { click: _vm.getTableData },
              },
              [_vm._v(_vm._s(_vm.$t("search.Refresh")))]
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: _vm.$t("general.index"),
              type: "index",
              width: "80",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: _vm.$t("trustDecision.ipAddress"),
              "min-width": "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", { staticClass: "ip-address" }, [
                      _vm._v(_vm._s(scope.row.ip)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: _vm.$t("general.operations"),
              width: "150",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleDelete(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("general.delete")))]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("trustDecision.addWhitelist"),
            visible: _vm.addDialogVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.addDialogVisible = $event
            },
            close: _vm.closeDialog,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: {
                model: _vm.addForm,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("trustDecision.ipAddress"),
                    prop: "ip",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.$t("trustDecision.enterIP") },
                    model: {
                      value: _vm.addForm.ip,
                      callback: function ($$v) {
                        _vm.$set(_vm.addForm, "ip", $$v)
                      },
                      expression: "addForm.ip",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.addDialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("general.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.addLoading },
                  on: { click: _vm.handleAdd },
                },
                [_vm._v(_vm._s(_vm.$t("general.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }